import { Component, Input, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { DevicesService, StateService, AppService } from '@services';

/*Models */
import { DailyQuality, Device } from '@models';

/*Plugins */

/*Plugins */
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import * as moment from 'moment';

/*Config*/
import { CONFIG } from '@config';

@Component({
	selector: 'app-pointer-graph',
	templateUrl: './pointer-graph.component.html',
	styleUrls: ['./pointer-graph.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PointerGraphComponent implements OnInit {
    @Input("value") value: number;
    currentColor;
    graphCount = [
        {
            width:0
        },
        {
            width:0
        },
        {
            width:0
        }
    ];

    ngOnInit(){
        if(this.value<=15){
            this.currentColor = "red";
        }else if(this.value>15 && this.value<90){
            this.currentColor = "yellow";
        }else{
            this.currentColor = "green";
        }
        let tempValue = parseInt(this.value.toString());
        if(tempValue<=100/3){
            this.graphCount[0].width = tempValue*100/(100/3);
        }else{
            tempValue = tempValue-100/3;
            this.graphCount[0].width = 100;
            if(tempValue<=100/3){
                this.graphCount[1].width = tempValue*100/(100/3);;
            }else{
                this.graphCount[1].width = 100;
                tempValue = tempValue-100/3;
                this.graphCount[2].width = tempValue*100/(100/3);;
            }
        }
       
    }
}





// WEBPACK FOOTER //
// ./src/app/view/components/pointer-graph/pointer-graph.component.ts